import { render, staticRenderFns } from "./cardAgrupacion.vue?vue&type=template&id=f8255272&"
import script from "./cardAgrupacion.vue?vue&type=script&lang=js&"
export * from "./cardAgrupacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports